<template>
	<div>
		<div class="btn-back  fcc" @click="back()">返回</div>
		<div class="page-coupons">


			<swiper :options="mySwiperOption" style="height: 100vh;">
				<swiper-slide v-for=" (item, index) in userCouponFormData" :key="index" style="height: 100vh;">
					<div class="inner">
						<div class="coupons-card">
							<div class="card-bg-hd">
								<div class="title-row fcc">
									<i></i>
									<div class="h1">
										{{ item.product.productName }}
									</div>
									<i></i>
								</div>
							</div>
							<!-- 已使用 -->
							<div class="stadus" v-if="item.state== 1">
								<!-- <img src="../assets/used-already.png" alt=""> -->
								<img src="../assets/used-already.png" alt="">
							</div>
							<div class="card-bg-bd">

								<div class="content">
									<div class="card-img">
										<img :src="item.product.banner" alt="">
									</div>
									<div class="title-bar">
										<div class="h3"><span>票券说明</span></div>
									</div>
									<div class="p">
										{{ item.product.content }}
									</div>


									<div class="title-bar">
										<div class="h3"><span>票券有效期</span></div>
									</div>
									<div class="p" v-if="item.product.longEffectiveFlag === 1">
										{{ '长期有效' }}
									</div>
									<div class="p" v-else>
										{{ item.product.startTime }} ~ {{ item.product.endTime }}
									</div>
								</div>
							</div>
							<div class="card-bd-ft">
								<div class="tips fc-bet" @click="showcheckInBoxFun(item)">
									<div class="icon fcc">
										<img src="../assets/73.png" alt="" >
									</div>
									<div class="p" v-if="item.state== 1">
										如果要使用此电子券，请点击此处盖章
									</div>
									<div class="p" style="color: #4a4a4a" v-else>
										如果要使用此电子券，请点击此处盖章
									</div>
								</div>
							</div>
						</div>
					</div>
				</swiper-slide>
				<!-- 左箭头 -->
				<div slot="button-prev" class="swiper-button-prev"></div>
				<!-- 右箭头 -->
				<div slot="button-next" class="swiper-button-next"></div>
			</swiper>




		</div>
		<div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
			<!--      <video src="@/assets/audio/duang.mp3"  ref="audio"  controls></video>-->
			<audio id="audioID" ref="audio" class="aud">
				<source src="https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/duang.mp3" type="audio/mp3" />
			</audio>
		</div>
		<van-overlay :show="load" @click="load = false">
        <div class="fcc-h " style="height: 100vh;" @click="load = false">
          <div class="brand-logo fcc rotateing">
            <div class="circle"></div>
            <!-- <img src="../assets/8.png" alt="" v-if="zhang"/> -->
            <img src="../assets/logoicon.png" alt="" />
          </div>
        </div>
      </van-overlay>
		<van-overlay :show="showcheckInBox" z-index="999" @click="showcheckInBox = false"
			@touchstart="handleTouchStart">
			<div class="fcc-h checkin-pop" style="height: 100vh;">
				<div class="fcc-h" style="width:90%;height: 45vh;" @click.stop>
					<div class="logo-wrap fcc">
						<div class="img fcc">
							<img src="../assets/logoicon.png" alt="" srcset="" />
						</div>
					</div>
					<div class="p fcc">
						请在屏幕上盖章
					</div>
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>


//页面引入vue-awesome-swiper 及其样式
import 'swiper/css/swiper.css'
import {
	Swiper,
	SwiperSlide
} from 'vue-awesome-swiper'

import { getRedeemList, checkTicket } from "@/api/api";
import { check } from "@/utils/check"
export default {
	components: {
		// 注册 vue-awesome-swiper 组件
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			showcheckInBox: false,
			showLoading: false,
			checking: false,
			productId: '',
			userCouponFormData:[],
			mySwiperOption: {
				effect: "coverflow",
				grabCursor: true,
				centeredSlides: true,
				slidesPerView: "auto",
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: false,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				//循环
				loop: false
			},
			currentItem:{},
			load: false
		}
	},
	mounted() {
		if (this.$route.query.productId) {
			this.productId = this.$route.query.productId
			this.getRedeemListFun()
		}
		this.$nextTick(() => {
			let Media = document.getElementById("audioID");
			Media.src = "https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/duang.mp3";
		})
	},
	methods: {
		async getRedeemListFun() {
			let res = await getRedeemList(this.productId)
			this.userCouponFormData = res.data
		},
		checkTicket() {
			if (this.checking) {
				return
			}
			this.showcheckInBox = false
			this.load = true
			let self = this
			checkTicket(this.currentItem.redeemCode).then(res => {
				if (res.success) {
					self.$toast("核销成功")
					document.querySelector('audio').play()
					document.getElementById("audioID").play()
					self.load = false
					self.getRedeemListFun()
				} else {
					self.$toast(res.message)
				}
			}).catch(err => {
				self.$toast("请稍后重试")
			}).finally(f => {
				self.checking = false
				self.showLoading = false
			})
		},
		showcheckInBoxFun(item) {
			if (item.state == 1) {
				// 已使用
				return
			}
			this.currentItem = item
			this.showcheckInBox = true
		},
		async handleTouchStart(event) {
			if (event.touches.length != 4) {
				return
			}
			// 获取触摸点的坐标
			let touchArr = []
			for (let i = 0; i < event.touches.length; i++) {
				var touchX = event.touches[i].clientX;
				var touchY = event.touches[i].clientY;
				let touchItem = [touchX, touchY]
				touchArr.push(touchItem)
			}
			let scope = check(touchArr)
			console.log("盖章：", scope)
			if (!scope) {
				// that.$toast("打卡失败，请重试")
				return
			}
			if (scope) {
				this.checkTicket()
			}
		},
	},

}

</script>

<style scoped="scoped" lang="less">
.brand-logo {
  width: 367px;
  height: 367px;

  margin: 50px auto 22px;
  position: relative;

  .circle {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url(../assets/8bg.png) center no-repeat;
    background-size: contain;
  }

  img {
    position: relative;
    width: 205px;
    height: 205px;
    display: block;
    object-fit: contain;
  }
}

.rotateing {
  .circle {
    -webkit-animation: circle 3s linear infinite;
    animation: circle 3s linear infinite;
  }
}


@keyframes circle {
  0% {
    -webkit-transform: rotate(0) scale(1.5);
    transform: rotate(0) scale(1.5);

  }

  // 33% {
  // 	-webkit-transform: rotate(720deg) scale(1.5);
  // 	transform: rotate(720deg) scale(1.5);
  // }
  // 67% {
  // 	-webkit-transform: rotate(1080deg) scale(1.5);
  // 	transform: rotate(1080deg) scale(1.5);
  // }
  100% {
    -webkit-transform: rotate(720deg) scale(1.5);
    transform: rotate(720deg) scale(1.5);
  }
}
</style>
